export default __webpack_public_path__ + "images/chatbot-cta-bg.f1dad7fe0be589e996bc4552d2867e0d.jpg";